import React from 'react';
import { VestingForm } from './VestingForm';
import { SectionName } from '../SectionName';

export const VestingSection: React.FC = () => {
  return (
    <section className="flex w-full gap-4">
      <SectionName>Grantee Vesting</SectionName>
      <VestingForm />
    </section>
  );
};
